module.exports = __webpack_public_path__ + "img/social.840a1d97.png";